'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DATA = exports.DATA = ['data'];
var STATUS = exports.STATUS = ['status'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/async-data/constants/keyPaths.js
// module id = 256
// module chunks = 2 3